import React from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { Button } from "@material-ui/core";
import { FrolaEditor } from "../../../../components/common";

function ConvTemplateContent({
  addTemplate,
  setAddTemplate,
  clickback,
  onAdd,
  conversationPlateform,
}) {

  const onHandleComDescription = model => {
    if (
      conversationPlateform?.platform === "Facebook" ||
      conversationPlateform?.platform === "Instagram"
    ) {
      setAddTemplate({ ...addTemplate, content: model.target.value });
    } else {
      setAddTemplate({ ...addTemplate, content: model });
    }
  };

  return (
    <div className='convTemplateContentWrapper'>
      <h3 className='convHeading '>
        <span onClick={clickback}>
          <ArrowBackIosIcon /> Back to Templates{" "}
        </span>
      </h3>
      <span className='templateTitle'>
        <h2>Title<span className="mandatorySign">*</span></h2>
        <input
          type='text'
          value={addTemplate?.title}
          onChange={x => {
            setAddTemplate({
              ...addTemplate,
              title: x.target.value,
            });
          }}
        />
      </span>

      <span className='templateBody'>
        <h2>Template Content<span className="mandatorySign">*</span></h2>
        <span className="chatEditor templateEditor">
          {/* <input
            type='text'
            value={addTemplate?.content}
            onChange={x => {
              setAddTemplate({
                ...addTemplate,
                content: x.target.value,
              });
            }}
          /> */}
          {/* <textarea 
           className='templateList'
            value={addTemplate?.content}
            onChange={x => {
              setAddTemplate({
                ...addTemplate,
                content: x.target.value,
              });
            }}
          /> */}
          <FrolaEditor
            model={addTemplate?.content}
            conversationPlateform={conversationPlateform?.platform}
            onHandleModelChange={model => onHandleComDescription(model)}
            comDescription={addTemplate?.content}
            maxWidth="100%"
          />
        </span>
      </span>

      <footer>
        <Button variant='outlined' onClick={clickback}>
          {" "}
          Cancel
        </Button>
        <Button
          color='primary'
          variant='contained'
          disabled={!addTemplate?.title || !addTemplate?.content}
          onClick={() => {
            onAdd(addTemplate);
          }}>
          {addTemplate?.id ? "Use" : "Create"}
        </Button>
      </footer>
    </div>
  );
}

export default ConvTemplateContent;
